import { HTTP } from './http';
import config from 'config';

const baseUrl = config.mdLiveApi;

export const requestScheduleAppointment = model =>
  new Promise((resolve, reject) =>
    HTTP.post(
      `${baseUrl}/v2/patients/${model.id}/appointments`,
      model.config
    )
      .then(response => (response.status === 201 ? resolve : reject)(response))
      .catch(error => reject(error.response))
  );

export const requestRetrievePatient = model =>
  new Promise((resolve, reject) =>
    HTTP.get(
      `${baseUrl}/v2/patients/${model}`
    )
      .then(response => (response.status === 200 ? resolve : reject)(response))
      .catch(error => reject(error.response))
  );

export const requestPatientDocumentList = model =>
  new Promise((resolve, reject) =>
    HTTP.get(
      `${baseUrl}/v1/patients/${model}/documents`
    )
      .then(response => (response.status === 200 ? resolve : reject)(response))
      .catch(error => reject(error.response))
  );

export const requestPatientDocument = model =>
  new Promise((resolve, reject) =>
    HTTP.get(
      `${baseUrl}/v1/patients/${model.id}/documents/${model.documentId}`
    )
      .then(response => (response.status === 200 ? resolve : reject)(response))
      .catch(error => reject(error.response))
  );

export const requestAppointmentUpcoming = model =>
  new Promise((resolve, reject) =>
    HTTP.get(
      `${baseUrl}/v2/patients/${model.id}/appointments/upcoming`, {
        headers: {
          Authorization: `Bearer ${model.token}`,
        },
      }
    )
      .then(response => (response.status === 200 ? resolve : reject)(response))
      .catch(error => reject(error.response))
  );

export const requestAppointmentF2fUpcoming = () => new Promise((resolve, reject) => HTTP.get('/appointments/latest')
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestCancelAppointment = model =>
  new Promise((resolve, reject) =>
    HTTP.put(
      `${baseUrl}/v1/patients/${model.patient}/appointments/${model.id}/cancel`,
    )
      .then(response => (response.status === 200 || response.status === 204 ? resolve : reject)(response))
      .catch(error => reject(error.response))
  );

export const requestVideoUrl = id =>
  new Promise((resolve, reject) =>
    HTTP.get(
      `${baseUrl}/v1/appointments/${id}/connection_params`,
    )
      .then(response => (response.status === 200 ? resolve : reject)(response))
      .catch(error => reject(error.response))
  );

export const createF2fAppointment = model => new Promise((resolve, reject) => HTTP.post('/appointments',
  {
    response: model,
  })
  .then(response => ((response.status === 201) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const updateF2fAppointment = (id, model) => new Promise((resolve, reject) => HTTP.patch(`/appointments/${id}`,
  {
    response: model,
  })
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestFinalizeAppointment = id => new Promise((resolve, reject) => HTTP.post(`/appointments/${id}/finalize`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestAppointmentQuery = model => new Promise((resolve, reject) => HTTP.post('/appointment-slot-queries', model)
  .then(response => ((response.status === 201) ? resolve : reject)(response))
  .catch(error => reject(error.response)));



// WEBPACK FOOTER //
// ./client/api/appointment.js